
export class StockChartAPIConstants {
}

export const APIMapping = {
    // Stock Chart
    RAINFALL_CHART_API: 'rf/rfChart',
    WINDSPEED_CHART_API: 'ws/wsChart',
    RAINFALL_BOTTOMBAR_API: 'rf/rfGridChart',
    WINDSPEED_BOTTOMBAR_API: 'ws/wsGridChart',
    TEMPERATURE_CHART_API: 'temperature/timeseries',
    TEMPERATURE_BOTTOMBAR_API: 'temperature/gridTimeseries',
    HUMIDITY_CHART_API: 'humidity/timeseries',
    HUMIDITY_BOTTOMBAR_API: 'humidity/gridTimeseries',
    RESERVOIR_CHART_API:'reservoir/chart',
    RIVERPOINT_CHART_API: 'riverpoints/chart',
    GROUNDWATER_CHART_API : 'gw/gwChart'
  };

  export const HierarchyMapping = {
    geo : ['state', 'district', 'mandal', 'groundwater'],
    geo_rainfall : ['state', 'district', 'mandal', 'aws']
  };
